import React, { useEffect, useState } from "react";
import { useLanguage } from "../../context/LanguageContext";
import LoadingSpinner from "../../components/ui/LoadingSpinner";

const Documentation: React.FC = () => {
    const { language } = useLanguage();
    const [iframeLoaded, setIframeLoaded] = useState(false);

    const srcLink = language === "FR" ? "https://rewind.notaku.site/" : "https://rewind-en.notaku.site";

    useEffect(() => {
        setIframeLoaded(false);
    }, [srcLink]);

    return (
        <div
            style={{ position: "relative", width: "100%", height: "calc(100vh - 76px)", background: "var(--surface)" }}
        >
            {!iframeLoaded && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1,
                        background: "var(--surface)",
                    }}
                >
                    <LoadingSpinner size={48} />
                </div>
            )}
            <iframe
                key={srcLink}
                src={srcLink}
                onLoad={() => setIframeLoaded(true)}
                style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    opacity: iframeLoaded ? 1 : 0,
                }}
                title="Notion Page"
                allowFullScreen
            />
        </div>
    );
};

export default Documentation;
